import React from 'react';
import { Modal, Input } from 'antd';
import DataService from '../../lib/DataService';
const Search = Input.Search;

export default class AddTeacherModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      title: props.title,
      showModal: props.showModal,
      teachers: props.teachers ? props.teachers : [],
      searchTeacherResult: [],
      hasSearched: false,
      addTeacher: props.callBack,
      schoolId: props.schoolId
    }

    this.searchTeacher = this.searchTeacher.bind(this);
    this.addTeacher = this.addTeacher.bind(this);
    this.handleInput = this.handleInput.bind(this);
  }

  componentWillReceiveProps(newProps) {
    this.setState({
      showModal: newProps.showModal,
      teachers: newProps.teachers ? newProps.teachers : [],
      value: "",
      title: newProps.title,
      hasSearched: false,
      schoolId: newProps.schoolId
    })
  }

  searchTeacher(name) {
    if (name !== '') {
      let {teachers, modal} = this.state;
      // hard code
      DataService.searchTeacher(name, this.state.schoolId).then(res => {
        let result = [];
        res.map(item => {
          if (teachers.find(teacher => {return teacher.id == item.id})) {
            item.joinState = true;
          }
          result.push(item);
        })
        this.setState({
          hasSearched: true,
          searchTeacherResult: result,
        })
      })
    }
  }

  addTeacher(e) {
    let index = e.currentTarget.dataset.index;
    let teacher = null;
    if (index !== undefined) {
      teacher = this.state.searchTeacherResult[index];
    }

    this.setState({
      searchTeacherResult: [],
      teachers: [],
      showModal: false,
    })

    this.state.addTeacher(teacher);
    this.props.onHideTeacherModel();
  }

  handleInput(e) {
    this.setState({
      value: e.target.value
    })
  }

  render() {
    return (
      <Modal
        className="add-teacher-modal"
        footer={null}
        title={null}
        onCancel={this.addTeacher}
        visible={this.state.showModal}
        maskClosable={false}
      >
        <p className="modal-title">{this.state.title}</p>
        <div className="search-teacher-box">
          <div className="input-box">
            <Search onSearch={this.searchTeacher} onChange={this.handleInput} value={this.state.value}/>
          </div>
          <div className="search-result">
            {this.state.searchTeacherResult && this.state.searchTeacherResult.map((item, index) => {
              return <div className="teacher-info" key={"search-" + index}>
                <div className="teacher-name">{item.full_name}</div>
                <div className="teacher-phone">{item.mobile_phone}</div>
                {item.joinState ? <div className="btn disabled">已选择</div> : <div className="btn" data-index={index} onClick={this.addTeacher}>选择</div>}
              </div>
            })}
            {(this.state.hasSearched && this.state.searchTeacherResult.length == 0) && <div className="no-result">无此老师，请先去教师管理进行添加</div>}
          </div>
        </div>
      </Modal>
    )
  }
}


// WEBPACK FOOTER //
// ./app/javascript/bundles/WebPcApp/components/share/AddTeacherModal.jsx